import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;

  .ant-input {
    width: 100%;
  }
`;

export const LoadingIndicator = styled.div<{ $visible: boolean }>`
  position: absolute;
  right: 11px;
  top: 4px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: none;
  transition: opacity 0.2s;
`;

export const HelpText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black5};
  margin-top: 4px;
`;
